import { useEffect, useRef, useState } from "react";
import benPiperFocus from "../assets/benPiperFocus.jpg";
import profile1 from "../assets/benPiper.jpg";
import profile2 from "../assets/profile.png";
import {
  ArrowLeft,
  ArrowRight,
  Award,
  Check2Circle,
  PersonCircle,
  PersonLinesFill,
  ShieldCheck,
  Translate,
} from "react-bootstrap-icons";

export default function Team() {
  const [activeBio, setActiveBio] = useState(null);
  const [showMoreRene, setShowMoreRene] = useState(false);
  const [showMoreBen, setShowMoreBen] = useState(false);

  const bioRef = useRef(null);

  useEffect(() => {
    if (activeBio !== null) {
      bioRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [activeBio]);

  const benExperience = [
    "Executive stress and burnout",
    "General anxiety and chronic worry",
    "Anxiety disorders and phobias",
    "Depression and low mood",
    "LGBTQ+ affirmative therapy",
    "Post traumatic stress reactions",
    "Adjustment to life changes and stressful events",
    "Sleep related difficulties",
    "Self-esteem difficulties",
    "Compassion focused work including shame and stigma",
    "Identity, sexuality and gender related concerns",
    "Meaning, purpose and values based work",
    // "Anxiety disorders and depression",
    // "Self esteem and relationship challenges",
    // "Executive stress and burnout",
    // "Trauma and adverse life experiences",
    // "LGBTQ plus affirmative therapy",
    // "Work related and identity difficulties",
  ];

  const reneExperience = [
    "General anxiety and chronic worry",
    "Anxiety disorders and phobias",
    "Depression and low mood",
    "Post traumatic stress reactions",
    "Adjustment to life changes and stressful events",
    "Eating and sleep related difficulties",
    "Relationship and interpersonal difficulties",
    "Compassion focused work including shame and stigma",
    "Identity, sexuality and gender related concerns",
    "Meaning, purpose and values based work",
  ];

  const experiencePreviewCount = 4;

  const benExperienceVisible = showMoreBen
    ? benExperience
    : benExperience.slice(0, experiencePreviewCount);

  const reneExperienceVisible = showMoreRene
    ? reneExperience
    : reneExperience.slice(0, experiencePreviewCount);

  return (
    <section id="team" className="py-5 bg-brand-orange text-white">
      <div className="py-4 main-wrap">
        {activeBio === null && (
          <div className="row align-items-center g-4">
            <div className="col-lg-4">
              <h2 className="h1 fw-semibold mb-3">Team</h2>
              <p className="mb-0 opacity-75">
                Meet the people behind iRise and the clinicians supporting your
                care.
              </p>
            </div>

            <div className="col-lg-8">
              <div className="row g-4">
                <div className="col-md-6">
                  <button
                    type="button"
                    className="p-0 border-0 bg-transparent w-100 text-start"
                    onClick={() => {
                      setActiveBio("ben");
                      setShowMoreBen(false);
                      setShowMoreRene(false);
                    }}
                    aria-label="Read bio for Dr Benjamin Piper"
                  >
                    <div className="p-4 rounded-4 bg-white bg-opacity-10 h-100 d-flex flex-column text-white border border-white border-opacity-25 shadow-sm">
                      <div className="d-flex flex-column flex-sm-row align-items-center align-items-sm-start text-center text-sm-start gap-3 mb-3">
                        <img
                          src={benPiperFocus}
                          alt="Dr Benjamin Piper"
                          className="team-portrait team-portrait-float rounded-circle shadow"
                        />
                        <div className="min-w-0 w-100">
                          <h3 className="h5 fw-semibold mb-1 text-uppercase">
                            Dr Benjamin Piper
                          </h3>
                          <p className="mb-0 opacity-75">
                            Counselling Psychologist and Clinical Director
                          </p>
                        </div>
                      </div>

                      <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between gap-2 mt-auto pt-2">
                        <span className="small opacity-75 d-inline-flex align-items-center">
                          <PersonLinesFill className="me-2" />
                          View profile
                        </span>
                        <span className="btn btn-light fw-semibold align-self-stretch align-self-sm-auto">
                          Read Bio <ArrowRight className="ms-2" />
                        </span>
                      </div>
                    </div>
                  </button>
                </div>

                <div className="col-md-6">
                  <button
                    type="button"
                    className="p-0 border-0 bg-transparent w-100 text-start"
                    onClick={() => {
                      setActiveBio("rene");
                      setShowMoreRene(false);
                      setShowMoreBen(false);
                    }}
                    aria-label="Read bio for Dr René de Barr"
                  >
                    <div className="p-4 rounded-4 bg-white bg-opacity-10 h-100 d-flex flex-column text-white border border-white border-opacity-25 shadow-sm">
                      <div className="d-flex flex-column flex-sm-row align-items-center align-items-sm-start text-center text-sm-start gap-3 mb-3">
                        <img
                          src={profile2}
                          alt="Dr René de Barr"
                          className="team-portrait team-portrait-float rounded-circle shadow"
                        />
                        <div className="min-w-0 w-100">
                          <h3 className="h5 fw-semibold mb-1 text-uppercase">
                            Dr René de Barr
                          </h3>
                          <p className="mb-0 opacity-75">
                            CBT Psychotherapist & Counselling Psychologist
                          </p>
                        </div>
                      </div>

                      <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between gap-2 mt-auto pt-2">
                        <span className="small opacity-75 d-inline-flex align-items-center">
                          <PersonLinesFill className="me-2" />
                          View profile
                        </span>
                        <span className="btn btn-light fw-semibold align-self-stretch align-self-sm-auto">
                          Read Bio <ArrowRight className="ms-2" />
                        </span>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeBio !== null && (
          <div ref={bioRef}>
            <div className="d-flex flex-wrap gap-2 justify-content-between align-items-center mb-4">
              <button
                type="button"
                className="btn btn-light fw-semibold"
                onClick={() => {
                  setActiveBio(null);
                  setShowMoreRene(false);
                  setShowMoreBen(false);
                }}
              >
                <ArrowLeft className="me-2" />
                Back to Team
              </button>

              <div
                className="d-flex flex-wrap gap-2"
                aria-label="Select team member"
              >
                <button
                  type="button"
                  className={
                    activeBio === "ben"
                      ? "btn btn-light fw-semibold"
                      : "btn btn-outline-light fw-semibold"
                  }
                  onClick={() => {
                    setActiveBio("ben");
                    setShowMoreBen(false);
                    setShowMoreRene(false);
                  }}
                >
                  <PersonCircle className="me-2" />
                  Dr Benjamin Piper
                </button>
                <button
                  type="button"
                  className={
                    activeBio === "rene"
                      ? "btn btn-light fw-semibold"
                      : "btn btn-outline-light fw-semibold"
                  }
                  onClick={() => {
                    setActiveBio("rene");
                    setShowMoreRene(false);
                    setShowMoreBen(false);
                  }}
                >
                  <PersonCircle className="me-2" />
                  Dr René de Barr
                </button>
              </div>
              
            </div>

            <div className="rounded-4 team-bio-card text-dark overflow-hidden shadow">
              {activeBio === "ben" && (
                <div className="p-4 p-lg-5">
                  <div className="d-flex flex-column align-items-center text-center mb-5">
                    <img
                      src={profile1}
                      alt="Dr Benjamin Piper"
                      className="team-portrait-active   img-fluid  shadow mb-3"
                    />

                    <h2 className="h3 fw-semibold mb-1 text-uppercase text-brand-orange">
                      Dr Benjamin Piper
                    </h2>
                    <p className="mb-2 text-muted">
                      Counselling Psychologist and Clinical Director
                    </p>

                    <div className="d-flex flex-wrap gap-2 justify-content-center mb-3">
                      <span className="badge text-bg-light border text-dark d-inline-flex align-items-center">
                        <Award className="me-2" />
                        CPsychol, BSc, MSc, PsychD
                      </span>
                    </div>

                    <div className="p-3 rounded-3 bg-light border">
                      <div className="fw-semibold mb-1 d-flex align-items-center justify-content-center">
                        <ShieldCheck className="me-2" />
                        Registered with
                      </div>
                      <div className="small text-muted">HCPC and BPS</div>
                    </div>
                  </div>

                  <div className="row g-4 align-items-start">
                    <div className="col-lg-5">
                      <h3 className="h6 fw-semibold text-uppercase text-brand-orange mb-2">
                        Areas of experience
                      </h3>

                      <ul className="list-group">
                        {benExperienceVisible.map((item) => (
                          <li className="list-group-item" key={item}>
                            <Check2Circle className="me-2" />
                            {item}
                          </li>
                        ))}
                      </ul>

                      <div className="d-flex align-items-center justify-content-between mt-2">
                        <span className="small text-muted">
                          Showing {benExperienceVisible.length} of{" "}
                          {benExperience.length}
                        </span>

                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary fw-semibold"
                          onClick={() => setShowMoreBen(!showMoreBen)}
                          aria-expanded={showMoreBen}
                          disabled={
                            benExperience.length <= experiencePreviewCount
                          }
                        >
                          {showMoreBen ? "Show less" : "Show more"}
                        </button>
                      </div>
                    </div>

                    <div className="col-lg-7">
                      <div className="team-bio-content mx-auto">
                        <div className="mb-4">
                          <h3 className="h6 fw-semibold text-uppercase text-brand-orange mb-2">
                            About
                          </h3>
                          <p className="mb-0">
                            I am a Chartered Counselling Psychologist based in
                            London and the Clinical Lead at iRise Psychology. I
                            am registered with both the Health and Care
                            Professions Council (HCPC) and the British
                            Psychological Society (BPS).
                          </p>
                        </div>

                        <div className="mb-4">
                          <h3 className="h6 fw-semibold text-uppercase text-brand-orange mb-2">
                            Approach
                          </h3>
                          <p className="mb-0">
                            I offer both short and long term therapy, drawing on
                            a range of evidence based approaches including
                            Cognitive Behavioural Therapy (CBT), EMDR, Schema
                            Therapy, and psychodynamic therapy. My work is
                            tailored to each individual, integrating these
                            models thoughtfully to best support your needs and
                            goals.
                          </p>
                        </div>

                        <div className="mb-4">
                          <h3 className="h6 fw-semibold text-uppercase text-brand-orange mb-2">
                            What therapy can help with
                          </h3>
                          <p className="mb-3">
                            Life can present painful experiences and ongoing
                            challenges within relationships, work, health, or
                            our sense of self that can feel overwhelming to
                            navigate alone. Working with a psychologist can
                            provide a supportive space to explore these
                            difficulties, understand where they originate, and
                            recognise the patterns that may be maintaining them.
                            Through this process, therapy can help foster
                            insight, emotional relief, and meaningful change.
                          </p>
                          <p className="mb-0">
                            Avoiding or pushing away difficult thoughts and
                            feelings can sometimes bring short term relief, but
                            often leaves underlying issues unresolved. Therapy
                            offers the opportunity to gently bring these
                            experiences into awareness, in a safe and contained
                            way, allowing them to be understood and worked
                            through rather than repeatedly resurfacing.
                          </p>
                        </div>

                        <div>
                          <h3 className="h6 fw-semibold text-uppercase text-brand-orange mb-2">
                            Background
                          </h3>
                          <p className="mb-0">
                            I have worked as a full time therapist for over 18
                            years, with more than 24 years experience within the
                            field of mental health. At iRise Psychology, we
                            believe that our greatest impact lies not only in
                            sharing valuable psychological ideas, but in
                            providing a safe, supportive, and collaborative
                            environment where people can feel understood as they
                            work towards profound and lasting change.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeBio === "rene" && (
                <div className="p-4 p-lg-5">
                  <div className="d-flex flex-column align-items-center text-center mb-5">
                    <img
                      src={profile2}
                      alt="Dr René de Barr"
                      className="team-portrait-active shadow mb-3"
                    />

                    <h2 className="h3 fw-semibold mb-1 text-uppercase text-brand-orange">
                      Dr René de Barr
                    </h2>
                    <p className="mb-2 text-muted">
                      CBT Psychotherapist & Counselling Psychologist
                    </p>

                    <div className="d-flex flex-wrap gap-2 justify-content-center mb-3">
                      <span className="badge text-bg-light border text-dark d-inline-flex align-items-center">
                        <Award className="me-2" />
                        BA, MA, MSc, PsychD
                      </span>

                      <span className="badge text-bg-light border text-dark d-inline-flex align-items-center">
                        <Translate className="me-2" />
                        English and Spanish
                      </span>
                    </div>

                    <div className="p-3 rounded-3 bg-light border">
                      <div className="fw-semibold mb-1 d-flex align-items-center justify-content-center">
                        <ShieldCheck className="me-2" />
                        Registered with
                      </div>
                      <div className="small text-muted">HCPC</div>
                    </div>
                  </div>

                  <div className="row g-4 align-items-start">
                    <div className="col-lg-5">
                      <h3 className="h6 fw-semibold text-uppercase text-brand-orange mb-2">
                        Areas of experience
                      </h3>

                      <p className="small text-muted mb-2">
                        Key areas include anxiety, low mood, trauma responses,
                        relationship difficulties, and identity and values work.
                      </p>

                      <ul className="list-group">
                        {reneExperienceVisible.map((item) => (
                          <li className="list-group-item" key={item}>
                            <Check2Circle className="me-2" />
                            {item}
                          </li>
                        ))}
                      </ul>

                      <div className="d-flex align-items-center justify-content-between mt-2">
                        <span className="small text-muted">
                          Showing {reneExperienceVisible.length} of{" "}
                          {reneExperience.length}
                        </span>

                        <button
                          type="button"
                          className="btn btn-sm btn-outline-secondary fw-semibold"
                          onClick={() => setShowMoreRene(!showMoreRene)}
                          aria-expanded={showMoreRene}
                        >
                          {showMoreRene ? "Show less" : "Show more"}
                        </button>
                      </div>
                    </div>

                    <div className="col-lg-7">
                      <div className="team-bio-content mx-auto">
                        <div className="mb-4">
                          <h3 className="h6 fw-semibold text-uppercase text-brand-orange mb-2">
                            About
                          </h3>
                          <p className="mb-0">
                            I am a CBT Psychotherapist and Counselling
                            Psychologist, registered with the Health and Care
                            Professions Council (HCPC), and I am able to conduct
                            therapy in both English and Spanish. My aim is to
                            provide a therapeutic experience where you feel
                            understood, supported, and met with empathy,
                            acceptance, and encouragement.
                          </p>
                        </div>

                        <div className="mb-4">
                          <h3 className="h6 fw-semibold text-uppercase text-brand-orange mb-2">
                            How we will work
                          </h3>
                          <p className="mb-0">
                            I work collaboratively with my clients to gain a
                            deeper understanding of themselves, their problems,
                            needs, and wants. Using a range of evidence based
                            psychotherapeutic techniques, I support clients in
                            finding ways to move beyond feelings of fear and
                            pain, towards a place that feels free, safe, calm,
                            and content. I also find it important to work with
                            clients on the bigger picture, helping them explore
                            what is important to them and what may make life
                            feel more meaningful.
                          </p>
                        </div>

                        <div className="mb-4">
                          <h3 className="h6 fw-semibold text-uppercase text-brand-orange mb-2">
                            Areas we may cover
                          </h3>
                          <p className="mb-0">
                            Our mental health can impact different areas of
                            life, including eating and sleep patterns, day to
                            day functioning, substance use, and social
                            relationships. In therapy, we explore how these
                            areas are affected and how we can make improvements
                            that feel supportive and sustainable.
                          </p>
                        </div>

                        <div>
                          <h3 className="h6 fw-semibold text-uppercase text-brand-orange mb-2">
                            Background
                          </h3>
                          <p className="mb-0">
                            I have ten years experience working in mental health
                            and seven years clinical experience. I have worked
                            in both private and NHS services. In addition, I
                            have conducted psychological research in areas
                            including compassion, shame and stigma, sex,
                            sexuality, gender, and relationships.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
